import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppClientUIModule, AppFrameCommonComponentsModule, ApplicationClientCommonModule, CommonFormattingModule, CommonLayoutModule, CommonTranslationModule, CommonUIModule, DictionaryModule, ServiceResponseModule, TMCTableModule, TransportInfoPanelModule } from '@sdbn/common';
import { QRCodeModule } from 'angularx-qrcode';
import { TmcYardCommonModule } from '../../../common/common.module';
import { TransportDetailsModule } from '../../../common/components/transport-details/transport-details.module';
import { StationSelectionModule } from '../../../components/station-selection/station-selection.module';
import { TaskAssignmentModule } from '../../../components/task-assignment/task-assignment.module';
import { TransportOptionsEditorModule } from '../../../components/transport-options-editor/transport-options-editor.module';
import { TransportOptionsPanelModule } from '../../../components/transport-options-panel/transport-options-panel.module';
import { ActionsModule } from '../../../control/actions/actions.module';
import { ForwardToStationModule } from '../forward-to-station/forward-to-station.module';
import { TransportDocumentsModule } from '../transport-documents/transport-documents.module';
import { CancelTransportDialogComponent } from './component/cancel-transport-dialog/cancel-transport-dialog.component';
import { CreateMovingOrderComponent } from './component/create-moving-order/create-moving-order.component';
import { GroupedListTitleComponent } from './component/grouped-list-title/grouped-list-title.component';
import { SacHeaderTabComponent } from './component/header-tab/header-tab.component';
import { LoadingZoneSelectionComponent } from './component/loading-zone-selection/loading-zone-selection.component';
import { ManagePlannedAssignmentsComponent } from './component/manage-planned-assignments/manage-planned-assignments.component';
import { PlannedAssignmentDetailsListEntryComponent } from './component/manage-planned-assignments/planned-assignment-details-list-entry/planned-assignment-details-list-entry.component';
import { PlannedAssignmentListEntryComponent } from './component/manage-planned-assignments/planned-assignment-list-entry/planned-assignment-list-entry.component';
import { SelectRoutingPositionComponent } from './component/manage-planned-assignments/select-routing-position/select-routing-position.component';
import { MobileSACComponent } from './component/mobile/mobile-sac/mobile-sac.component';
import { MobileStationSelectionMenuComponent } from './component/mobile/mobile-station-selection-menu/station-selection-menu.component';
import { MobileStationDetailsComponent } from './component/mobile/station-details/station-details.component';
import { MobileSacStationTitleComponent } from './component/mobile/station-tile/station-title.component';
import { MobileSacTransportActionsComponent } from './component/mobile/transport-actions/transport-actions.component';
import { MobileSacTransportDetailsComponent } from './component/mobile/transport-details/transport-details.component';
import { MobileSacTransportDocumentsComponent } from './component/mobile/transport-documents/transport-documents.component';
import { MovingOrderVehicleSelectionComponent } from './component/moving-order-vehicle-selection/moving-order-vehicle-selection.component';
import { MovingOrderTransportSelectionComponent } from './component/planned-transport-selection/planned-transport-selection.component';
import { SacClientContainerComponent } from './component/sac-client-container/sac-client-container.component';
import { SacHeaderContainerComponent } from './component/sac-header-container/sac-header-container.component';
import { SACStationTabletPlannedAssignmentsComponent } from './component/station-tablet/planned-station-assignments/sac-station-tablet-planned-assignments.component';
import { SACStationTabletComponent } from './component/station-tablet/sac-station-tablet/sac-station-tablet.component';
import { EmptyWorkingAreaItemComponent } from './component/stations/empty-workingarea-item/empty-workingarea-item.component';
import { SacStationDetailsComponent } from './component/stations/sac-station-details/sac-station-details.component';
import { StationTransortActionBarComponent } from './component/stations/sac-station-details/station-transport-action-bar/station-transport-action-bar.component';
import { StationTransportDetailsComponent } from './component/stations/sac-station-details/station-transport-details/station-transport-details.component';
import { WaitingAreaDetailsComponent } from './component/stations/sac-station-details/waiting-area-details/waiting-area-details.component';
import { SacStationItemComponent } from './component/stations/sac-station-item/sac-station-item.component';
import { SacStationsComponent } from './component/stations/sac-stations.component';
import { SacWorkingAreaComponent } from './component/stations/sac-working-area/sac-working-area.component';
import { SuspendStationDialogComponent } from './component/stations/sac-working-area/suspend-station-dialog/suspend-station-dialog.component';
import { UsedWorkingareaItemComponent } from './component/stations/used-workingarea-item/used-workingarea-item.component';
import { WaitingAreaItemComponent } from './component/stations/waiting-area/waiting-area-item.component';
import { TransportDetailsListEntryComponent } from './component/transport-details-list-entry/transport-details-list-entry.component';
import { TransportListEntryComponent } from './component/transport-list-entry/transport-list-entry.component';
import { TransportOptionGcConnectionDialogComponent } from './component/transport-option-gc-connection-dialog/transport-option-gc-connection-dialog.component';
import { TransportOptionSelectionComponent } from './component/transport-option-selection/transport-option-selection.component';
import { SacTransportComponent } from './component/transports/sac-transports.component';
import { SacBeginUmbrueckungDialogComponent } from './component/umbrueckung/sac-begin-umbrueckung-dialog.component';
import { SacCompleteUmbrueckungDialogComponent } from './component/umbrueckung/sac-complete-umbrueckung-dialog.component';



@NgModule({
  declarations: [
    SacClientContainerComponent,
    SacStationsComponent,
    SacTransportComponent,
    GroupedListTitleComponent,
    TransportListEntryComponent,
    TransportDetailsListEntryComponent,
    SacStationItemComponent,
    SacStationDetailsComponent,
    SacBeginUmbrueckungDialogComponent,
    SacCompleteUmbrueckungDialogComponent,
    CancelTransportDialogComponent,
    StationTransortActionBarComponent,
    WaitingAreaDetailsComponent,
    StationTransportDetailsComponent,
    SacWorkingAreaComponent,
    SuspendStationDialogComponent,
    SacHeaderContainerComponent,
    SacHeaderTabComponent,
    EmptyWorkingAreaItemComponent,
    UsedWorkingareaItemComponent,
    WaitingAreaItemComponent,
    TransportOptionSelectionComponent,
    TransportOptionGcConnectionDialogComponent,
    CreateMovingOrderComponent,
    MovingOrderTransportSelectionComponent,
    MovingOrderVehicleSelectionComponent,
    LoadingZoneSelectionComponent,
    MobileSACComponent,
    MobileSacStationTitleComponent,
    MobileStationDetailsComponent,
    MobileStationSelectionMenuComponent,
    MobileSacTransportDetailsComponent,
    MobileSacTransportActionsComponent,
    MobileSacTransportDocumentsComponent,
    ManagePlannedAssignmentsComponent,
    PlannedAssignmentListEntryComponent,
    PlannedAssignmentDetailsListEntryComponent,
    SelectRoutingPositionComponent,
    SACStationTabletComponent,
    SACStationTabletPlannedAssignmentsComponent
  ],
  imports: [
    CommonModule,
    CommonTranslationModule,
    CommonUIModule,
    CommonLayoutModule,
    CommonFormattingModule,
    FormsModule,
    ReactiveFormsModule,
    TransportDetailsModule,
    FormsModule,
    TransportInfoPanelModule,
    StationSelectionModule,
    TMCTableModule,
    ApplicationClientCommonModule,
    TmcYardCommonModule,
    TransportOptionsEditorModule,
    QRCodeModule,
    ForwardToStationModule,
    DictionaryModule,
    TmcYardCommonModule,
    ServiceResponseModule,
    TransportOptionsPanelModule,
    TransportDocumentsModule,
    TaskAssignmentModule,
    ActionsModule,
    AppClientUIModule,
    AppFrameCommonComponentsModule,
    CommonUIModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTableModule,
    MatDividerModule,
    MatMenuModule,
    MatSortModule,
    MatRadioModule,
    MatInputModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatDialogModule
  ],
  exports: [
    TransportListEntryComponent
  ]
})
export class SacClientModule { }
